import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Slider from 'react-slick'
import { Division, RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  divisions: Division[]
}

export const NextArrow = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className="next arrow-custom"
    >
      <i className="icon-arrow-stick-light"></i>
    </div>
  )
}
export const PrevArrow = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className="prev arrow-custom"
    >
      <i className="icon-arrow-stick-light"></i>
    </div>
  )
}

const Hero_7 = ({
  items,
  opacityValue,
  backgroundHexa,
  hidden,
  height,
  customFontSize,
  spanText,
  paragraphElement,
  titleColor,
  paragraphColor,
}: RealEstateDataPageComponentData & ExternalProps) => {
  const settingsSlick: any = {
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: 0,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  function ResaltarTexto({ texto }: any) {
    const regex = /\/\/(.*?)\/\//gs // 's' para permitir coincidencias con saltos de línea
    const textoFormateado = texto.replace(regex, '<span class="text-primary">$1</span>')

    return <div dangerouslySetInnerHTML={{ __html: textoFormateado }} />
  }

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    isMounted && (
      <section
        style={{
          height: height
            ? screen?.width < 992
              ? height?.mobile !== '0' && height?.mobile !== null
                ? height?.mobile + 'vh'
                : `calc(90vh)`
              : height?.desktop !== '0' && height?.desktop !== null
              ? height?.desktop + 'vh'
              : `calc(90vh)`
            : '',
        }}
        className={'hero-5-component ' + (hidden ? 'hidden-controll' : '')}
      >
        <Slider {...settingsSlick}>
          {items?.map((item, i) => (
            <div
              className="item-slider"
              key={i}
            >
              <div
                className={'opacity-background '}
                style={{
                  backgroundColor: backgroundHexa || '#6b6b6b6',
                  opacity:
                    opacityValue && opacityValue !== '0'
                      ? Number(opacityValue) !== 100
                        ? `0.${Number(opacityValue)}`
                        : 1
                      : 0.6,
                }}
              ></div>
              {item.image_gatsby && (
                <Image
                  alt={'image' + i}
                  className="absolute-image"
                  objectFit="cover"
                  image={item?.image_gatsby!}
                ></Image>
              )}
              <div className="content w-100">
                {item.title && (
                  <div className="section-title mb-4 mb-lg-4">
                    {item.title.split('\n').map((titl, index) => (
                      <h1
                        style={{
                          fontSize: customFontSize !== 0 ? customFontSize + 'rem' : '',
                          color: titleColor || '#fff',
                        }}
                        key={index}
                      >
                        {<ResaltarTexto texto={titl} />}
                      </h1>
                    ))}
                  </div>
                )}
                {item.paragraph &&
                  item.paragraph.split('\n').map((para, index) =>
                    para ? (
                      <ElementHTML
                        key={index}
                        children={para}
                        elementType={paragraphElement || 'p'}
                        style={{
                          color: paragraphColor || '#fff',
                          maxWidth: screen?.width < 992 ? '' : spanText,
                        }}
                      />
                    ) : (
                      // <p key={index}>{para}</p>
                      <div className="d-block separator w-100"></div>
                    ),
                  )}
                {item.image_bottom && (
                  <Image
                    alt={'image' + i}
                    className="image_bottom"
                    image={null}
                    objectFit="cover"
                    hrefImage={item?.image_bottom}
                  ></Image>
                )}
              </div>
            </div>
          ))}
        </Slider>
      </section>
    )
  )
}

export default Hero_7
